export default "__VITE_ASSET__DXVpf6qD__"